import React, { useEffect, useState } from "react";
import axios from "axios";
import copy from "copy-to-clipboard";
import { Button, Header, Icon, Segment } from "semantic-ui-react";

export default function WebsiteMarketing(props) {
  const [marketingUrl, setMarketingUrl] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    axios.get(`/profile/`).then(({ data }) => {
      setMarketingUrl(data.marketing_url);
    });
  }, []);

  const textToCopy = `<a href="${marketingUrl}" target="_blank" title="Atwood Rentals">
    <img
      src="https://atwood-assets.s3.us-east-2.amazonaws.com/atwood-dealer-link.png"
      alt="Apply Now for an Atwood Rentals Rent-To-Own Comfort System"
      style="width: 500px; display: block;"
    />
  </a>`;

  function onCopyClick() {
    copy(textToCopy);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 5000);
  }

  return (
    <Segment padded>
      <Header
        content="Website Marketing"
        subheader="Add the image below to your website"
      />
      <a href={marketingUrl} target="_blank" title="Atwood Rentals">
        <img
          src="https://atwood-assets.s3.us-east-2.amazonaws.com/atwood-dealer-link.png"
          alt="Apply Now for an Atwood Rentals Rent-To-Own Comfort System"
          style={{ width: "400px", margin: "10px 0" }}
        />
      </a>
      <p>Click copy code below for website usage</p>
      {copied && (
        <p>
          <Icon color="green" name="circle check" /> Copied to clipboard!
        </p>
      )}
      {!copied && (
        <Button
          // onClick={(e) => copy(props.url)}
          onClick={() => onCopyClick()}
          icon="copy"
          content="Copy Code"
          basic
          size="small"
        />
      )}
    </Segment>
  );
}
